export enum ObjectiveStatus {
    OnTrack = "OnTrack",
    Slow = "Slow",
    Stuck = "Stuck",
    Complete = "Complete",
    Closed = "Closed",
}

export class ObjectiveStatusMetadata {
    public static readonly OnTrack = new ObjectiveStatusMetadata(ObjectiveStatus.OnTrack, "On track", "objective-status-on-track", 0);
    public static readonly Slow = new ObjectiveStatusMetadata(ObjectiveStatus.Slow, "Slow", "objective-status-slow", 1);
    public static readonly Stuck = new ObjectiveStatusMetadata(ObjectiveStatus.Stuck, "Stuck", "objective-status-stuck", 2);
    public static readonly Complete = new ObjectiveStatusMetadata(ObjectiveStatus.Complete, "Complete", "objective-status-complete", 3);
    public static readonly Closed = new ObjectiveStatusMetadata(ObjectiveStatus.Closed, "Closed", "objective-status-closed", 4);

    public static readonly All = [
        ObjectiveStatusMetadata.OnTrack,
        ObjectiveStatusMetadata.Slow,
        ObjectiveStatusMetadata.Stuck,
        ObjectiveStatusMetadata.Complete,
        ObjectiveStatusMetadata.Closed,
    ];

    public static readonly ByStatus: { [status in ObjectiveStatus]: ObjectiveStatusMetadata } = {
        [ObjectiveStatus.OnTrack]: ObjectiveStatusMetadata.OnTrack,
        [ObjectiveStatus.Slow]: ObjectiveStatusMetadata.Slow,
        [ObjectiveStatus.Stuck]: ObjectiveStatusMetadata.Stuck,
        [ObjectiveStatus.Complete]: ObjectiveStatusMetadata.Complete,
        [ObjectiveStatus.Closed]: ObjectiveStatusMetadata.Closed,
    };

    private constructor(
        public readonly status: ObjectiveStatus,
        public readonly name: string,
        public readonly statusClass: string,
        public readonly sortOrdinal: number,
    ) { }
}
